import { render } from "./ModulePersonalizationAdminView.vue?vue&type=template&id=0bebea9d&scoped=true"
import script from "./ModulePersonalizationAdminView.vue?vue&type=script&lang=js"
export * from "./ModulePersonalizationAdminView.vue?vue&type=script&lang=js"

import "./ModulePersonalizationAdminView.vue?vue&type=style&index=0&id=0bebea9d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bebea9d"]])

export default __exports__